import { api } from './api';

export const getProductsByCategory = async (categoryId: string) => {
  const { data } = await api.get(`/products/category/${categoryId}/active`);
  return data;
}
